// extracted by mini-css-extract-plugin
export default {"component":"LeftPart_component__e1N0C"};